module.exports = __webpack_public_path__ + "assets/images/joy-0ac90a5cb9a3127aabe648204b9ae79d.png";